/**
 * Global Imports
*/

import React, { useState } from 'react';

/**
 * Local Contexts
*/



/**
 * Exports
*/

export const PageContext = React.createContext({});

/**
 * 
 */
export function PageProvider(props) {
  /** States **/
  
  const [ title, setTitle ] = useState(null);
  const [ group, setGroup ] = useState(null);
  const [ route, setRoute ] = useState(null);
  const [ breadcrumbs, setBreadcrumbs ] = useState(null);

  /** Event Handlers **/

  /**
   * 
   */
  const handleChange = ({ title, group, route, breadcrumbs }) => {
    setTitle(title);
    setGroup(group);
    setRoute(route);
    setBreadcrumbs(breadcrumbs);
  };
  
  /** Output **/
  
  return (
    <PageContext.Provider
      value={{
        change: handleChange,
        title, setTitle,
        group, setGroup,
        route, setRoute,
        breadcrumbs, setBreadcrumbs
      }}
    >
      { props.children }
    </PageContext.Provider>
  );
}